export default __webpack_public_path__ + "static/media/0001.57bdbc26.jpg";